<template>
  <div>
    <div class="heaer-text">收入报表</div>
    <div style="overflow: hidden">
      <income-filter
        @imconlistKey="imconlistKey"
        @showLoading="showLoading"
        @downloadFile="downloadFile"
      ></income-filter>
    </div>
    <div>
      <income-table
        :incomeList="incomeList"
        :column="column"
        :loading="loading"
        ref="usertable"
        :totalColumn="totalColumn"
        @computTotalColumn="computTotalColumn"
      ></income-table>
    </div>
  </div>
</template>

<script>
import IncomeFilter from "./incomeFilter";
import IncomeTable from "./incomeTable";
import { income_table_column } from "../../config/table_comlun";
export default {
  name: "income",
  data() {
    return {
      key: "",
      loading: true,
      totalColumn: [],
    };
  },
  computed: {
    incomeList: function () {
      return this.$store.state.Income.incomList;
    },
    column: function () {
      // let arr = []
      return income_table_column(
        {
          date: "0",
          geo: "总计",
          incomeTotalUSD: "0.00",
          rmbTotal: "0.00",
          usd: "0.00",
        },
        this.key,
        this.$store.state.Income.isRmbMap
      );
      // return arr
    },
  },
  // mounted() {
  //   let param = {
  //     order: "asc",
  //     offset: 0
  //   };
  //   this.$store.dispatch("getProductTableList", {
  //     param,
  //     cb: () => {}
  //   });
  // },
  methods: {
    showLoading() {
      this.loading = true;
    },
    imconlistKey(value) {
      this.key = value;
      this.loading = false;
      this.$refs.usertable.refresh();
    },
    downloadFile() {
      this.$refs.usertable.downLoadFileToExcel();
    },
    computTotalColumn(arr) {
      this.totalColumn = arr;
    },
  },
  components: {
    IncomeFilter,
    IncomeTable,
  },
};
</script>
<style scoped>
.heaer-text {
  padding: 16px 16px 6px 16px;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
}
</style>
